import { Form, Modal, Select } from '@pankod/refine-antd'
import React from 'react'

import { CertificateTemplate } from '@resources/lms-management/certificate-template/types'

type CreateTemplateDesignModalProps = {
  visible?: boolean
  onClose?: () => void
  onConfirm?: (
    data: Pick<CertificateTemplate, 'kapabilitas' | 'certificateType'>,
  ) => Promise<void>
  unavailableTypes?: { kapabilitas: string; certificateType: string }[]
}

const kapabilitasOptions = [
  {
    label: 'Peserta',
    value: 'peserta',
  },
  {
    label: 'Fasilitator',
    value: 'instruktur',
  },
  {
    label: 'Pengajar Praktik',
    value: 'asisten',
  },
  {
    label: 'Instruktur Webinar',
    value: 'instruktur_webinar',
  },
]

const certificateTypeOptions = [
  { label: 'Penyelesaian (Lulus)', value: 'COMPLETION' },
  { label: 'Partisipasi (Tidak Lulus)', value: 'PARTICIPATION' },
]

const CreateTemplateDesignModal = ({
  visible,
  onClose,
  onConfirm,
  unavailableTypes,
}: CreateTemplateDesignModalProps) => {
  const [form] = Form.useForm()
  const handleCancel = () => {
    form.resetFields()
    onClose?.()
  }

  const kapabilitasValue = Form.useWatch('kapabilitas', form)

  return (
    <Modal
      title="Buat Desain Template Sertifikat"
      visible={visible}
      onCancel={handleCancel}
      onOk={async () => {
        await form.validateFields()
        await onConfirm?.({
          ...form.getFieldsValue(),
        })
        handleCancel()
      }}
      okText="Buat Desain"
      cancelText="Batal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Kapabilitas"
          name="kapabilitas"
          rules={[{ required: true, message: 'Kapabilitas harus diisi' }]}
          dependencies={['certificateType']}
        >
          <Select
            options={kapabilitasOptions}
            placeholder="Pilih kapabilitas"
            allowClear
          />
        </Form.Item>
        <Form.Item
          label="Jenis Sertifikat"
          name="certificateType"
          rules={[{ required: true, message: 'Jenis Sertifikat harus diisi' }]}
          dependencies={['kapabilitas']}
        >
          <Select
            options={certificateTypeOptions.map((item) => ({
              ...item,
              disabled: unavailableTypes?.some(
                (type) =>
                  type.certificateType === item.value &&
                  type.kapabilitas === kapabilitasValue,
              ),
            }))}
            placeholder="Pilih jenis sertifikat"
            allowClear
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateTemplateDesignModal
